import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface Company {
  id: number;
  name: string;
  posSetSelectorPrivileges: {
    createPrivilege: boolean | null;
    deletePrivilege: boolean | null;
    getPrivilege: boolean;
    getPrivilegeCompany: boolean;
    modifyPrivilege: boolean | null;
  };
}

interface SelectComponentProps {
  menuItems: Company[];
  label: string;
  value: Company | null;
  setValue: (value: Company | null) => void;
  posSet: string;
}

const CompanyOrBuSelector: React.FC<SelectComponentProps> = ({ menuItems, label, value, setValue, posSet }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const selected = menuItems.find(elem => elem.id === Number(event.target.value)) || null;
    localStorage.setItem(posSet, event.target.value);
    setValue(selected);
  };

  React.useEffect(() => {
    const posSetId = localStorage.getItem(posSet);
    if (posSetId) {
      const selected = menuItems.find(elem => elem.id === Number(posSetId)) || null;
      setValue(selected);
    }
  }, [menuItems, posSet, setValue]);

  return (
    <FormControl sx={{ userSelect: 'none', width: '300px', marginBottom: '16px' }}>
      <InputLabel id="custom-select-label">{label}</InputLabel>
      <Select
        labelId="custom-select-label"
        label={label}
        value={value ? String(value.id) : ''}
        onChange={handleChange}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.id} value={String(item.id)}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CompanyOrBuSelector;